import { ReactComponent as LeftWithPumpSvg } from '../../../images/manifold/left-with-pump.paths.svg';

type Props = {
  xTransform: number;
  yTransform: number;
};
export const LeftWithPumpPaths = ({ xTransform, yTransform }: Props) => {
  return (
    <g transform={`matrix(0, -1, 1, 0, ${xTransform}, ${yTransform})`}>
      <LeftWithPumpSvg />
    </g>
  );
};
